import React from "react";
// Components
import VerticalCard from "../generic/VerticalCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory, useParams } from "react-router-dom";
// jquery
import $ from "jquery";

const CardAddComunidad = styled(VerticalCard)`
    background-color: aliceblue;
    :hover {
        box-shadow: 0 0px 6px #2a599f !important;
    }
`;

const ComunidadAddTarjeta = ({ ...props }) => {

    let history = useHistory();
    let { id_p } = useParams()
    let defaultImg = `/images/logoSTJ.png`;
    let img = `${process.env.REACT_APP_API_URL}/download/provincias/${id_p}/` ? `${process.env.REACT_APP_API_URL}/download/provincias/${id_p}/` : defaultImg;

    let title = `Añadir nueva comunidad a la provincia`;

    const addStarndardCommunity = () => {
        //llamo a la api para que añada una nueva comunidad en blanco con los parámetros mínimos
        const data = {
            name: '- Edite la NUEVA comunidad -',
            key: '000',
        }
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/provincias/${id_p}/comunidades`,
            method: "POST",
            xhrFields: {
                withCredentials: true,
            },
            data: data,
        };
        $.ajax(settings);
        history.go(0);
    }

    return (
        <CardAddComunidad onClick={addStarndardCommunity}
            cardImage={img}
            title={title}
            imgOnError={defaultImg} {...props}>
        </CardAddComunidad>
    );
};

export default ComunidadAddTarjeta;
